<template>
  <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl mx-auto">
      <form @submit.prevent="store">
        <div class="p-6 sm:p-8 -mr-6 -mb-6 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-6 w-full lg:w-1/2"
            :label="__('Name')" :disabled="!user_access.category.create" />

          <checkbox-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-6 w-full lg:w-1/2"
            :label="__('Active')" :disabled="!user_access.category.create" />
        </div>
        <div class="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center space-x-2">
          <Link class="btn-gray" :href="route('faq-categories.cancel')" method="post" as="button" type="button"
            preserve-scroll>
          {{ __('Cancel') }}
          </Link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit"
            :disabled="!user_access.category.create">
            {{ __('Create') }} {{ __('Category') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import CheckboxInput from '@/Shared/CheckboxInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    LoadingButton,
    CheckboxInput,
    TextInput,
    Link,
    Head,
    Layout
  },
  layout: Layout,
  props: {
    auth: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        status: true,
      }),
      user_access: this.$page.props.auth.user.access || {},
    }
  },
  methods: {
    store() {
      this.form.post(route('faq-categories.store'), {
        preserveScroll: true,
        onSuccess: () => {
          this.$inertia.visit(route('faqs.index'))
        },
        onError: () => {
          // Handle validation errors
        }
      })
    },
  },
}
</script>
